export default class UserContactNotificationsDialog {
  constructor($scope, $rootScope, $q, UserContactService) {
    $scope.$on('show_user_contact_notifications', function(event, data) {
      window.openFancyboxDialog('div#user_contact_notifications_dialog');
      $scope.user_contact = data.user_contact;
      load_notifications();
    });

    function load_notifications() {
      $scope.finished = false;
      $scope.notifications = [];
      $scope.notificationIndex = null;
      $scope.notification = null;
      UserContactService.get_notifications($scope.user_contact.id).success(function(data) {
        $scope.notifications = data.notifications;
        if ($scope.notifications.length > 0) {
          $scope.display_notification(0);
        }
        $scope.finished = true;
      });
    }

    $scope.display_notification = function(index) {
      if (index < 0 || index >= $scope.notifications.length) {
        return;
      }

      $scope.notificationIndex = index;
      $scope.notification = $scope.notifications[index];
    };

  }
}

UserContactNotificationsDialog.$inject = ['$scope', '$rootScope', '$q', 'UserContactService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-contact-notifications-dialog.ctrl.js